import type { ReactNode } from "react";
import { cn, layout } from "@/utilities/tailwind-utils";
import { LoadingSpinner } from "./loading-spinner";

interface RefreshingOverlayProps {
  isRefreshing: boolean;
  children: ReactNode;
  className?: string;
}

/**
 * Keeps surrounding chrome mounted while a list refetch is in flight.
 * Filters and headers stay interactive; only the wrapped results dim and
 * show a spinner.
 */
export function RefreshingOverlay({
  isRefreshing,
  children,
  className
}: RefreshingOverlayProps) {
  return (
    <div
      className={cn(
        "relative",
        isRefreshing && "min-h-[min(40vh,320px)]",
        className
      )}
      aria-busy={isRefreshing}
    >
      {isRefreshing && (
        <div
          className={cn(
            "absolute inset-0 z-10 rounded-xl bg-background/60",
            layout.flexCenter
          )}
        >
          <LoadingSpinner size="md" showText={false} />
        </div>
      )}
      <div
        className={cn(
          "transition-opacity duration-200",
          isRefreshing && "opacity-60 pointer-events-none"
        )}
      >
        {children}
      </div>
    </div>
  );
}
